import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
import {
  SAVE_COLLECTION_DOCS,
  SAVE_COLLECTION_ID,
  SAVE_COLLECTIONS
} from "@/store/mutation-types";

export default {
  actions: {
    loadCollections: async ({ commit }) => {
      return ApiRequest.exploreGet(
        "collections",
        GetHeaders.dataHeaders()
      ).then(res => {
        commit(SAVE_COLLECTIONS, { collections: res.data });
      });
    },
    loadCollectionDocs: async ({ commit }, payload) => {
      return ApiRequest.exploreGet(
        "collection/" + payload,
        GetHeaders.dataHeaders()
      ).then(res => {
        commit(SAVE_COLLECTION_ID, { id: payload });
        commit(SAVE_COLLECTION_DOCS, { docs: res.data.documents });
      });
    },
    saveCollection: async ({ dispatch }, payload) => {
      return ApiRequest.explorePost(
        "collection",
        payload.collection,
        GetHeaders.dataHeaders()
      ).then(() => {
        dispatch("loadCollections");
      });
    },
    addDocumentToCollection: async ({ state, dispatch }, payload) => {
      return ApiRequest.explorePost(
        "collection",
        {
          collection_id: payload.collectionId,
          documents: [payload.documentId]
        },
        GetHeaders.dataHeaders()
      ).then(() => {
        dispatch("loadCollectionDocs", state.collectionId);
        dispatch("loadCollections");
      });
    },
    removeDocumentFromCollection: async ({ state, dispatch }, payload) => {
      return ApiRequest.explorePost(
        "collection/",
        {
          collection_id: payload.collectionId,
          remove_documents: [payload.documentId]
        },
        GetHeaders.dataHeaders()
      ).then(() => {
        dispatch("loadCollectionDocs", state.collectionId);
        dispatch("loadCollections");
      });
    }
  },
  getters: {},
  mutations: {
    [SAVE_COLLECTIONS](state, payload) {
      state.collections = payload.collections;
    },
    [SAVE_COLLECTION_ID](state, payload) {
      state.collectionId = payload.id;
    },
    [SAVE_COLLECTION_DOCS](state, payload) {
      state.collectionDocs = payload.docs;
    }
  },
  state: {
    collections: [],
    collectionId: null,
    collectionDocs: []
  }
};
